// ----------------------------------------------------------------------
// <copyright file="Izenda.QuerySourceType.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * QuerySourceType component
 */

import React, { Component, PropTypes } from 'react';
import { action } from 'mobx';
import localizer from 'share/localization/Izenda.Localizer';
import Button from 'share/components/controls/Izenda.Button';
import CommonMessages from 'share/messages/Izenda.CommonMessages';
import IconMenu from 'share/components/controls/Izenda.IconMenu';
import ActionBar from 'share/components/controls/Izenda.ActionBar';
import DataGridSearch from 'share/components/controls/DataGrid/Izenda.DataGridSearch';
import Alert from 'share/components/controls/Izenda.Alert';
import connect from 'share/enhancers/Izenda.Connect';
import actions from './Izenda.QuerySourceTypeActions';
import QuerySourceTypeContent from './Izenda.QuerySourceTypeContent';
import { QUERY_SOURCE_TYPE } from 'logic/data/Izenda.DataModelConstants';
import CustomViewPopup from './Izenda.CustomViewPopup';
import { get } from 'lodash/fp';

@connect(actions)
class QuerySourceType extends Component {
  static propTypes = {
    store: PropTypes.object.isRequired
  };

  componentDidMount() {
    this.props.store.init();
    this.updateQuerySourceType(this.props.querySourceType);
  }

  componentWillUnmount() {
    this.props.store.destroy();
  }

  componentWillReceiveProps(nextProps) {
    var props = this.props;

    if (nextProps.querySourceType !== props.querySourceType) {
      props.store.alertMessage = CommonMessages.EMPTY_MESSAGE;
      this.updateQuerySourceType(nextProps.querySourceType);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.querySourceType !== this.props.querySourceType;
  }

  updateQuerySourceType = action(querySourceType => {
    const props = this.props;
    const { loader, store } = props;

    props.updateLoading(true);
    loader.startLoading();
    store
      .setQuerySourceType(querySourceType)
      .then(props.updateLoading.bind(props, false))
      .finally(loader.endLoading.bind(loader));
  });

  renderAlertMessage = () => {
    const { store } = this.props;

    const resetAlertMessageFunc = () => {
      store.alertMessage = CommonMessages.EMPTY_MESSAGE;
    };

    return (
      store.alertMessage.message && (
        <div className="izenda-Alert-container">
          <Alert type={store.alertMessage.type} onAutoHide={resetAlertMessageFunc}>
            {store.alertMessage.message}
          </Alert>
        </div>
      )
    );
  };

  onAddCustomView = () => {
    this.props.openPopup(CustomViewPopup, { store: this.props.store });
  };

  render() {
    const props = this.props;
    const { store, authorization, authorizationConstants: { PERMISSION_KEY } } = props;
    const isTabView = get('parentStore.activeLink', props) === QUERY_SOURCE_TYPE.VIEW;
    const canAddCustomView = authorization.checkPrivileges([PERMISSION_KEY.DataSetupDataModelCustomViewCreate]);

    return (
      <section className="izenda-Wrapper izenda-QuerySource">
        <div className="izenda-Wrapper-header">
          <IconMenu className="u_marginRightInnerSpace" />

          {this.renderAlertMessage()}

          <div className="u_inlineBlock">
            <DataGridSearch
              options={store.getCriteriaList}
              value={store.pageInfo.searchProperty}
              onSearch={props.onSearch}
              searchValue={store.pageInfo.searchText}
            />
          </div>

          <ActionBar onSave={props.onSave} onCancel={props.onCancel}>
            {isTabView &&
              canAddCustomView && (
                <Button onClick={this.onAddCustomView} label={localizer.getText('DATA_MODEL_LABEL_ADD_CUSTOM_VIEW')} />
              )}
          </ActionBar>
        </div>

        <QuerySourceTypeContent
          store={props.store}
          querySourceType={props.querySourceType}
          width={props.width}
          height={props.height}
          searchProperty={props.searchProperty}
          searchValue={props.searchValue}
          isNotHighLight={props.isNotHighLight}
          isLoading={props.isLoading}
        />
      </section>
    );
  }
}

export default QuerySourceType;



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/DataModel/QuerySourceType/Izenda.QuerySourceType.js